import { handleActions } from 'redux-actions';
import { fetchTagList, setTagError, setTagFilters, setTagList } from './actions';

const defaultState = {
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    sortBy: '',
    searchText: '',
    isSortOrderDescending: false,
    status: null,
  },
  totalRecords: 0,
  data: [],
  options: [],
  error: null,
};

export default handleActions(
    {
      [fetchTagList](state) {
        return {
          ...state,
          loading: true,
          data: [],
        };
      },
      [setTagList](state, {payload}) {
        return {
          ...state,
          loading: false,
          data: payload.records,
          totalRecords: payload.totalRecords,
          error: null,
        };
      },
      [setTagError](state, {payload}) {
        return {
          ...state,
          data: [],
          loading: false,
          totalPages: defaultState.totalPages,
          error: payload?.message,
        };
      },
      [setTagFilters](state, {payload}) {
        return {
          ...state,
          filters: {
            ...state.filters,
            ...payload,
          },
        };
      },
    },
    defaultState,
);
